import articleDialog from './index.vue';
 
// 定义插件对象
const ArticleDialog = {};
// vue的install方法，用于定义vue插件
ArticleDialog.install = function (Vue, options) {
  const ArticleDialogInstance = Vue.extend(articleDialog);
  let currentMsg;
  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new ArticleDialogInstance();
    let msgBoxEl = currentMsg.$mount().$el;
    document.body.appendChild(msgBoxEl);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$articleDialog = {
    showArticleDialog (options) {
      if (!currentMsg) {
        initInstance();
      }
      if (typeof options === 'string') {
        currentMsg.content = options;
      } else if (typeof options === 'object') {
        Object.assign(currentMsg, options);
      }
      currentMsg.showMsgBox();
    },
    hideArticleDialog (options) {
      if (!currentMsg) {
        initInstance();
      }
      currentMsg.cancel();
    }
  };
};
 
export default ArticleDialog;


// WEBPACK FOOTER //
// ./src/components/common/article-dialog/index.js